import React from 'react';
import {Button, DatePicker, Descriptions, Form, Select, Space} from "antd";
import InputNumberFormated from "./InputNumberFormated";
import locale from 'antd/es/date-picker/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

const BookingForm = ({booking, handleSubmit, buildings, handleChangeBuilding}) => {

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }

  const initialValues = {
    ...booking,
    start_at: dayjs(booking.start_at, 'DD/MM/YYYY'),
    end_at: dayjs(booking.end_at, 'DD/MM/YYYY'),
  };

  return (
    <>
      <Form
        initialValues={initialValues}
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      >
        <Descriptions
          bordered
          column={1}
          size="middle"
          styles={{label:{ width: '200px' }}}
        >
          <Descriptions.Item label="Locataire" span={1}>
            {booking.tenant?.personne?.nom} {booking.tenant?.personne?.prenom}
          </Descriptions.Item>
          <Descriptions.Item label="Immeuble" span={1}>
            <Form.Item
              label={null}
              name="building_id"
              style={{ marginLeft: 32, marginBottom:0 }}
            >
              <Select
                showSearch
                onChange={handleChangeBuilding}
                options={buildings?.map((build) => ({ label: `${build.nom}`, value: build.id }))}
              />
            </Form.Item>
          </Descriptions.Item >
          <Descriptions.Item label="Période" span={1}>
            <Space wrap align={"center"}>
              <Form.Item
                label="Du"
                name="start_at"
                style={{marginBottom:0}}
              >
                <DatePicker
                  allowClear={false}
                  locale={locale}
                  format="DD/MM/YYYY"
                />
              </Form.Item>

              <Form.Item
                label="Au"
                name="end_at"
                style={{marginBottom:0}}
              >
                <DatePicker
                  allowClear={false}
                  locale={locale}
                  format="DD/MM/YYYY"
                />
              </Form.Item>

            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="Montant location" span={1}>
            <Form.Item
              label={null}
              name="price"
              style={{ marginLeft: 32, marginBottom:0 }}
            >
              <InputNumberFormated
                style={{maxWidth: 150}}
              />
            </Form.Item>

          </Descriptions.Item>

        </Descriptions>
        <Form.Item
          label={null}
          style={{marginBottom:0}}
        >
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop:15 }}>
            <Button
              htmlType="submit"
              type="primary"
            >Modifier la réservation
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default BookingForm;